import React, { useState } from "react";
import Sidbar from "../../organisms/chat/Sidbar";
import ChatContainer from "../../organisms/chat/ChatContainer";
import "./chat.scss";
import useGet from "../../customHooks/useGet/UseGet";
import { newUser } from "../../lib/user";
const Chat = () => {
  const [selectedUser, setSelectedUser] = useState(null);

  const handleUserSelect = (user) => {
    setSelectedUser(user);
  };
  const { data } = useGet(`list_vendor?`);
  const messages = useGet(`get-messages/${newUser?.id}/${selectedUser?.id}`);

  return (
    <div className="container-fluid px-5 my-3">
      <div className="row">
        <Sidbar
          handleUserSelect={handleUserSelect}
          selectedUser={selectedUser}
          users={data?.vendors || []}
        />
        <ChatContainer selectedUser={selectedUser} messages={messages} />
      </div>
    </div>
  );
};

export default Chat;
